import commonStyles from '../../../../assets/jss/commonStyles';

const styles = {
  ...commonStyles,
  webhookBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '0.85rem',
    fontWeight: 500,
  },
  webhookActive: {
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
  },
  webhookInactive: {
    backgroundColor: '#f5f5f5',
    color: '#757575',
  },
};

export default styles;
